import styled from "styled-components";

const Home = styled.div`
	background: black;
	height: 100vh;
	background-size: cover;
	background-position: center;
	display: flex;
	align-items: center;
	justify-content: center;
	color: white;
	font-weight: bold;
	font-family: "Poppins", sans-serif;
	padding-top: 6%;
	//#F5A92C #2f2e40
	h1 {
		font-size: 3.3rem;
		line-height: 1.5;
	}
	p {
		font-size: 80%;
	}
	.hero-image {
		width: 20%;
		padding-left: 1rem;
		display: flex;
		justify-content: center;
		align-items: center;

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}
`;

export default Home;
